import { Icon, IconButton } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';

import classes from './sidebars.module.css';

export type TabNavProps = {
  tabs: { value: string; icon: IconComponent }[];
  active: string;
  onSelect: (value: string) => void;
};

const TabNav = ({ tabs, active, onSelect }: TabNavProps) => (
  <div className={classes.tabRow}>
    {tabs.map(tab => (
      <div
        key={tab.value}
        className={`${classes.tab}${active === tab.value ? ` ${classes.active}` : ''}`}
        onClick={() => onSelect(tab.value)}
      >
        <IconButton>
          <Icon icon={tab.icon} />
        </IconButton>
      </div>
    ))}
  </div>
);

export default TabNav;
